import React from 'react'
import './gestionBusqueda.scss'
const GestionBusquedaContenido = ({title, children}) => {
  return (
    <div className='gestionBusquedaContenido w-100'>
    <legend>{title}</legend>
    <div className='row'>
            {children}
    </div>
  </div>
  )
}

export default GestionBusquedaContenido